// src/router.js
import VueRouter from "vue-router";
import organisers from "./config.js";
import { getAccessContext, hasToolAccess } from "./admin/access.js";

const RootNotFound = () => import(/* webpackChunkName: "static-pages" */ "./components/RootNotFound.vue");
const PrivacyPolicy = () => import(/* webpackChunkName: "static-pages" */ "./components/PrivacyPolicy.vue");

const RegisterForm = () => import(/* webpackChunkName: "registration-flow" */ "./components/Form.vue");
const Update = () => import(/* webpackChunkName: "registration-flow" */ "./components/Registration/Update.vue");

const DeliveryPage = () => import(/* webpackChunkName: "clip-delivery" */ "./components/DeliveryPage.vue");
const DigitalDownloadDelivery = () => import(/* webpackChunkName: "digital-download-delivery" */ "./components/DigitalDownload/DigitalDownloadDelivery.vue");

const Snapshot = () => import(/* webpackChunkName: "snapshot-flow" */ "./components/Snapshot/Snapshot.vue");
const Download = () => import(/* webpackChunkName: "snapshot-flow" */ "./components/Snapshot/Download.vue");
const LegacySnapshot = () => import(/* webpackChunkName: "legacy-snapshot-flow" */ "./components/Snapshot/LegacySnapshot/LegacySnapshot.vue");

const FindStudentProcess = () => import(/* webpackChunkName: "submission-editor" */ "./components/Submissions/FindStudentProcess");
const Thumbnails = () => import(/* webpackChunkName: "submission-editor" */ "./components/Submissions/Thumbnails");
const AudioTool = () => import(/* webpackChunkName: "submission-editor" */ "./components/Submissions/AudioTool/AudioTool.vue");
const Help = () => import(/* webpackChunkName: "submission-help" */ "./components/Submissions/Help.vue");
const AutomaticSubmissionAccept = () => import(/* webpackChunkName: "submission-auto-accept" */ "./components/AutomaticSubmissionAccept.vue");

const StoreProducts = () => import(/* webpackChunkName: "store-flow" */ "./components/Purchases/StoreProducts.vue");
const StoreSuccess = () => import(/* webpackChunkName: "store-flow" */ "./components/Purchases/StoreSuccess");
const StoreCancel = () => import(/* webpackChunkName: "store-flow" */ "./components/Purchases/StoreCancel");
const PurchaseForm = () => import(/* webpackChunkName: "store-checkout" */ "./components/Purchases/Form.vue");
const DigitalDownloadForm = () => import(/* webpackChunkName: "store-checkout" */ "./components/Purchases/DigitalDownload/DigitalDownloadForm.vue");
const CompleteShopifyReg = () => import(/* webpackChunkName: "store-checkout" */ "./components/Purchases/Shopify/CompleteReg.vue");

const Login = () => import(/* webpackChunkName: "admin-auth" */ "./components/Admin/Login.vue");
const Admin = () => import(/* webpackChunkName: "admin-shell" */ "./components/Admin/Admin.vue");
const ChooseAction = () => import(/* webpackChunkName: "admin-shell" */ "./components/Admin/ChooseAction.vue");
const Upload = () => import(/* webpackChunkName: "admin-upload" */ "./components/Admin/Upload.vue");
const SnapshotBulkUpload = () => import(/* webpackChunkName: "admin-snapshot" */ "./components/Admin/SnapshotBulkUpload.vue");
const SnapshotPhotoAdmin = () => import(/* webpackChunkName: "admin-snapshot" */ "./components/Admin/SnapshotPhotoAdmin.vue");
const SnapshotConfiguration = () => import(/* webpackChunkName: "admin-snapshot" */ "./components/Admin/SnapshotConfiguration.vue");
const SnapshotOperations = () => import(/* webpackChunkName: "admin-snapshot" */ "./components/Admin/SnapshotOperations.vue");
const SnapshotOrders = () => import(/* webpackChunkName: "admin-snapshot" */ "./components/Admin/SnapshotOrders.vue");
const ShareTemplates = () => import(/* webpackChunkName: "admin-messaging" */ "./components/Admin/ShareTemplates.vue");
const UploadNotifications = () => import(/* webpackChunkName: "admin-messaging" */ "./components/Admin/UploadNotifications.vue");
const SourceInputs = () => import(/* webpackChunkName: "admin-source-inputs" */ "./components/Admin/SourceInputs.vue");
const ImportsList = () => import(/* webpackChunkName: "admin-imports" */ "./components/Admin/Imports/ImportsList.vue");
const ImportWizard = () => import(/* webpackChunkName: "admin-imports" */ "./components/Admin/Imports/ImportWizard.vue");
const OrdersAnalytics = () => import(/* webpackChunkName: "admin-analytics" */ "./components/Admin/OrdersAnalytics.vue");
const SalesPerformance = () => import(/* webpackChunkName: "admin-analytics" */ "./components/Admin/SalesPerformance.vue");
const AnalyticsDashboard = () => import(/* webpackChunkName: "admin-analytics" */ "./components/Admin/AnalyticsDashboard.vue");
const ClipsExplorer = () => import(/* webpackChunkName: "admin-clips" */ "./components/Admin/ClipsExplorer.vue");
const CustomerOperations = () => import(/* webpackChunkName: "admin-customer-operations" */ "./components/Admin/CustomerOperations.vue");
const CeremonySearch = () => import(/* webpackChunkName: "admin-ceremony-search" */ "./components/Admin/CeremonySearch.vue");
const CeremonyHighlightCollectionsIndex = () => import(/* webpackChunkName: "admin-ceremony-search" */ "./components/Admin/CeremonyHighlightCollectionsIndex.vue");
const CeremonyHighlightCollections = () => import(/* webpackChunkName: "admin-ceremony-search" */ "./components/Admin/CeremonyHighlightCollections.vue");
const UserManagement = () => import(/* webpackChunkName: "admin-users" */ "./components/Admin/UserManagement.vue");
const SupportReview = () => import(/* webpackChunkName: "admin-support" */ "./components/Admin/SupportReview.vue");
const SurveyStudio = () => import(/* webpackChunkName: "admin-surveys" */ "./components/Admin/SurveyStudio.vue");

const partialroutes = [
  {
    path: "/",
    component: RootNotFound,
    name: "registerRoot",
    auth: false
  },
  {
    path: "/snapshot/:uni",
    component: Snapshot,
    name: "snapshotForm",
    auth: false,
    props: { name: "" }
  },
  {
    path: "/snapshot/:uni/order/:nanoId/download",
    component: Download,
    name: "snapshotDownload",
    auth: false,
    props: { name: "" }
  },
  {
    path: "/legacy-snapshot/:uni",
    component: LegacySnapshot,
    name: "legacySnapshotForm",
    auth: false,
    props: { name: "" }
  },
  {
    path: "/:uni-register",
    component: RegisterForm,
    name: "register",
    auth: false
  },
  {
    path: "/clip/:uni/:id",
    component: DeliveryPage,
    props: {},
    auth: false
  },
  {
    path: "/clip/:uni",
    component: DeliveryPage,
    props: {},
    auth: false
  },
  {
    path: "/clip/:uni/:id/audio",
    component: AudioTool,
    props: {},
    auth: false
  },
  {
    path: "/clip/:uni/:id/help",
    component: Help,
    props: {},
    auth: false
  },
  {
    path: "/digital-download/:uni/:id/download",
    component: DigitalDownloadDelivery,
    props: {},
    auth: false
  },
  {
    path: "/submission/:id",
    component: FindStudentProcess,
    auth: false
  },
  {
    path: "/submission/:id/automatic",
    component: AutomaticSubmissionAccept,
    auth: false
  },
  {
    path: "/store/:uni",
    component: StoreProducts,
    auth: false
  },
  {
    path: "/store/:uni/success",
    component: StoreSuccess,
    auth: false
  },
  {
    path: "/store/:uni/cancel",
    component: StoreCancel,
    auth: false
  },
  {
    path: "/store/:uni/purchase",
    component: PurchaseForm,
    auth: false
  },
  {
    path: "/store/:uni/purchase/digital-download",
    component: DigitalDownloadForm,
    auth: false
  },
  {
    path: "/store/:uni/complete-registration/:id",
    component: CompleteShopifyReg,
    auth: false
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: { auth: true },
    children: [
      {
        path: "choose",
        component: ChooseAction,
        name: "choose",
        meta: { auth: true }
      },
      {
        path: "upload",
        component: Upload,
        name: "upload",
        meta: { auth: true, permission: "upload" }
      },
      {
        path: "snapshot-bulk",
        component: SnapshotBulkUpload,
        name: "snapshotBulk",
        meta: { auth: true, permission: "snapshotBulk" }
      },
      {
        path: "snapshot-collections/:collectionId/photos",
        component: SnapshotPhotoAdmin,
        name: "snapshotCollectionPhotos",
        meta: { auth: true, permission: "snapshotBulk" }
      },
      {
        path: "snapshot-photo-sets/:photoSetId/photos",
        component: SnapshotPhotoAdmin,
        name: "snapshotPhotoSetPhotos",
        meta: { auth: true, permission: "snapshotBulk" }
      },
      {
        path: "snapshot-problems",
        component: SnapshotPhotoAdmin,
        name: "snapshotProblems",
        meta: { auth: true, permission: "snapshotBulk" }
      },
      {
        path: "snapshot-config",
        component: SnapshotConfiguration,
        name: "snapshotConfiguration",
        meta: { auth: true, permission: "snapshotConfig" }
      },
      {
        path: "snapshot-operations",
        component: SnapshotOperations,
        name: "snapshotOperations",
        meta: { auth: true, permission: "snapshotBulk" }
      },
      {
        path: "snapshot-orders",
        component: SnapshotOrders,
        name: "snapshotOrders",
        meta: { auth: true, permission: "snapshotOrders" }
      }
      ,
      {
        path: "share-templates",
        component: ShareTemplates,
        name: "shareTemplates",
        meta: { auth: true, permission: "shareTemplates" }
      },
      {
        path: "source-inputs",
        component: SourceInputs,
        name: "sourceInputs",
        meta: { auth: true, permission: "sourceInputs" }
      }
      ,
      {
        path: "upload-notifications",
        component: UploadNotifications,
        name: "uploadNotifications",
        meta: { auth: true, permission: "uploadNotifications" }
      },
      {
        path: "imports",
        component: ImportsList,
        name: "imports",
        meta: { auth: true, permission: "imports" }
      },
      {
        path: "imports/new",
        component: ImportWizard,
        name: "importWizardNew",
        meta: { auth: true, permission: "importsWrite" }
      },
      {
        path: "imports/:id",
        component: ImportWizard,
        name: "importWizard",
        meta: { auth: true, permission: "imports" }
      },
      {
        path: "order-analytics",
        component: OrdersAnalytics,
        name: "ordersAnalytics",
        meta: { auth: true, permission: "ordersAnalytics" }
      },
      {
        path: "sales-performance",
        component: SalesPerformance,
        name: "salesPerformance",
        meta: { auth: true, permission: "salesPerformance" }
      },
      {
        path: "ceremony-search",
        component: CeremonySearch,
        name: "ceremonySearch",
        meta: { auth: true, permission: "semanticCeremonySearch" }
      },
      {
        path: "ceremony-search/highlights",
        component: CeremonyHighlightCollectionsIndex,
        name: "ceremonyHighlightCollections",
        meta: { auth: true, permission: "semanticCeremonySearch" }
      },
      {
        path: "ceremony-search/highlights/:collectionId",
        component: CeremonyHighlightCollections,
        name: "ceremonyHighlights",
        meta: { auth: true, permission: "semanticCeremonySearch" }
      },
      {
        path: "analytics",
        component: AnalyticsDashboard,
        name: "analyticsDashboard",
        meta: { auth: true, permission: "analytics" }
      },
      {
        path: "clips",
        component: ClipsExplorer,
        name: "clipsExplorer",
        meta: { auth: true, permission: "clipsExplorer" }
      },
      {
        path: "customer-operations",
        component: CustomerOperations,
        name: "customerOperations",
        meta: { auth: true, permission: "customerOperations" }
      },
      {
        path: "users",
        component: UserManagement,
        name: "userManagement",
        meta: { auth: true, permission: "userManagement" }
      },
      {
        path: "surveys",
        component: SurveyStudio,
        name: "surveyStudio",
        meta: { auth: true, permission: "surveyStudio" }
      },
      {
        path: "support-review",
        component: SupportReview,
        name: "supportReview",
        meta: { auth: true, permission: "supportReview" }
      }
    ],
    auth: true
  },
  {
    path: "/admin/login",
    component: Login,
    name: "login",
    auth: false
  },
  {
    path: "/thumbnails/:uni/:id",
    component: Thumbnails,
    auth: false
  },
  {
    path: "/:uni/registration/:id/update",
    component: Update,
    auth: false
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    auth: false
  }
];

const generateRoutesForOrganisations = function (orgs) {
  var additionalRoutes = [];
  for (const [key, value] of Object.entries(orgs)) {
    additionalRoutes.push({
      path: "/" + key,
      component: RegisterForm,
      props: { organiser: value }
    });
  }
  return additionalRoutes;
};

const routes = partialroutes.concat(generateRoutesForOrganisations(organisers));
const router = new VueRouter({
  mode: "history",
  routes
});

function isChunkLoadError(error) {
  const message = error && error.message ? error.message : "";
  const name = error && error.name ? error.name : "";
  return (
    name === "ChunkLoadError" ||
    /Loading (CSS )?chunk \d+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

function resetChunkLoadReloadFlag() {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  window.sessionStorage.removeItem("graduate-frontend-chunk-reload");
}

router.onError((error) => {
  if (!isChunkLoadError(error) || typeof window === "undefined") return;
  const key = "graduate-frontend-chunk-reload";
  try {
    if (window.sessionStorage && !window.sessionStorage.getItem(key)) {
      window.sessionStorage.setItem(key, "1");
      window.location.reload();
    }
  } catch (e) {
    window.location.reload();
  }
});

router.afterEach(resetChunkLoadReloadFlag);

import Auth from "./api/auth.js";
import axios from "axios";
import { trackEvent } from "./Analytics.vue";
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.auth || (record.meta && record.meta.auth));
  if (requiresAuth) {
    const context = getAccessContext();
    if (!context.valid) {
      Auth.clearSession();
      return next({ path: "/admin/login" });
    }
    Auth.authenticated = true;
    if (context.token) axios.defaults.headers.common["Authorization"] = "Bearer " + context.token;
    const matchWithPermission = [...to.matched].reverse().find((record) => record.meta && record.meta.permission);
    const permissionKey = matchWithPermission && matchWithPermission.meta.permission;
    if (!context.hasUniversities && to.path !== "/admin/choose" && !(
      permissionKey && hasToolAccess(permissionKey, context)
    )) {
      return next({ path: "/admin/choose" });
    }
    if (matchWithPermission) {
      if (!hasToolAccess(permissionKey, context)) {
        return next({ path: "/admin/choose" });
      }
    }
  }
  trackEvent(to.path, { label: "PAGE", from: from.path });
  next();
});

export default router;
